export const initialValues = {
  new_password: "",
  confirm_password: "",
};
